"use strict";
// PostHog provider, hooks, and direct client access.
// All PostHog integration code lives here — including the event-name registry
// at `./events/<Feature>/`.
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.posthog = exports.POSTHOG_FEATURE_FLAGS = exports.usePostHogEvent = exports.ChatSessionContextProvider = exports.EventContextProvider = exports.GaiaPostHogProvider = void 0;
var posthog_js_1 = __importDefault(require("posthog-js"));
exports.posthog = posthog_js_1.default;
var PostHogProvider_1 = require("./PostHogProvider");
Object.defineProperty(exports, "GaiaPostHogProvider", { enumerable: true, get: function () { return PostHogProvider_1.GaiaPostHogProvider; } });
Object.defineProperty(exports, "EventContextProvider", { enumerable: true, get: function () { return PostHogProvider_1.EventContextProvider; } });
Object.defineProperty(exports, "ChatSessionContextProvider", { enumerable: true, get: function () { return PostHogProvider_1.ChatSessionContextProvider; } });
var usePostHogEvent_1 = require("./usePostHogEvent");
Object.defineProperty(exports, "usePostHogEvent", { enumerable: true, get: function () { return usePostHogEvent_1.usePostHogEvent; } });
var flags_1 = require("./flags");
Object.defineProperty(exports, "POSTHOG_FEATURE_FLAGS", { enumerable: true, get: function () { return flags_1.POSTHOG_FEATURE_FLAGS; } });
